// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { ComponentContainer } from "../framework/components/ComponentContainer";
import { ComponentLabel } from "../framework/components/ComponentLabel";
import { ComponentPicture } from "../framework/components/ComponentPicture";
import { DialogBase } from "../framework/dialogs/DialogBase";
import { tgfDictionary } from "../framework/tgfDictionary";
import { tgfDialogs } from "../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../framework/tgfGraphics";
import { tgfSettings } from "../framework/tgfSettings";
import { DialogSettings } from "../settings/Settings";
import { s_practice_match_floater } from "./AssetDefinitions/ImageDefinitions";
tgfSettings.dialogDefaults.PracticeFloaterDialog = {
    width: 800,
    height: 550,
    font: DialogSettings.textFont,
    smallFont: DialogSettings.textFontSmall,
    buttonFont: DialogSettings.buttonFont,
    fadeTime: 250,
    duration: 2500,
    components: [] // The additional components to add
};
export var PracticeFloaterDialog = function (properties) {
    "use strict";
    this.name = "PracticeFloaterDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.PracticeFloaterDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
};
// Inherit the base dialog
tgfDialogs.inherit(PracticeFloaterDialog, DialogBase);
PracticeFloaterDialog.prototype.doPrepare = function () {
    "use strict";
    this.container = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
    });
    this.addComponent(this.container);
    this.picture = new ComponentPicture({
        image: s_practice_match_floater
    });
    this.container.addComponent(this.picture);
    this.label = new ComponentLabel({
        text: tgfDictionary.getText("BTN_PRACTICE_MATCH"),
        font: this.font
    });
    this.container.addComponent(this.label);
};
PracticeFloaterDialog.prototype.startAnimation = function () {
    this.setAlpha(0);
    this._animationTime = 0;
    this._isAnimationRunning = true;
};
PracticeFloaterDialog.prototype.setAlpha = function (alpha) {
    this.picture.setAlpha(alpha);
    this.label.setAlpha(alpha);
};
PracticeFloaterDialog.prototype.handleEndStep = function (deltaTime) {
    PracticeFloaterDialog.uber.handleEndStep.call(this);
    if (this._isAnimationRunning) {
        this._animationTime += deltaTime;
        if (this._animationTime < this.fadeTime) {
            this.setAlpha(this._animationTime / this.fadeTime);
        }
        else if (this._animationTime < this.fadeTime + this.duration) {
            this.setAlpha(1);
        }
        else if (this._animationTime < this.fadeTime * 2 + this.duration) {
            this.setAlpha((this.fadeTime * 2 + this.duration - this._animationTime) / this.fadeTime);
        }
        else {
            this.setAlpha(0);
            this._isAnimationRunning = false;
            if (this.onDone) {
                this.onDone();
            }
        }
    }
};
